<template>
		<van-button v-if="isPhone" type="info" size="small" style="margin-left: 3%;width: 15%;" @click="landscape">{{screen}}</van-button>
</template>

<script>
	export default {
	  name: 'screenButton',
	  data(){
		  return{
			  screen:"横屏",
			  isPhone:false,
		  }
	  },
	  mounted() {
		if(window.matchMedia("(orientation:portrait)").matches){
			this.screen="横屏"
		}else{
			this.screen="竖屏"
		}
		 dd.device.base.getPhoneInfo({
		    onSuccess: (data)=> {
				this.isPhone=true
		    },
		    onFail: function(err) {
		        alert(JSON.stringify(err));
		    }
		});
	  },
	  methods: {
		  landscape(){
		  		  if(this.screen=="横屏"){
		  			  this.screen="恢复"
		  			dd.device.screen.rotateView({
		  		    showStatusBar: true,
		  		    clockwise: true,
		  		    success: () => {},
		  		    fail: () => {},
		  		    complete: () => {},
		  		  });
		  		}else{
		  			this.screen="横屏"
		  			dd.device.screen.resetView({
		  			    onSuccess : function(result) {
		  			    },
		  			    onFail : function(err) {}
		  			});
		  		}
		  },
		
	  }
	}

</script>